<div class="container py-5 text-center">
  <div class="card shadow-sm p-4 border-0 rounded-4">
    <h3 class="text-danger mb-3 fw-bold">
      <i class="bi bi-exclamation-triangle-fill"></i> Confirmar eliminación
    </h3>

    <p class="fs-5 text-secondary mb-4">
      ¿Estás seguro de que deseas eliminar la <strong>variedad</strong> con código 
      <strong class="text-dark">{{ codigo }}</strong>? <br />
      Esta acción <span class="text-danger fw-semibold">no se puede deshacer</span>.
    </p>

    <div class="d-flex justify-content-center gap-3">
      <button class="btn btn-outline-secondary btn-lg px-4" (click)="onCancel()">
        <i class="bi bi-arrow-left"></i> Cancelar
      </button>

      <button class="btn btn-danger btn-lg px-4" (click)="onConfirmDelete()" [disabled]="loading()">
        @if (loading()) {
          <span class="spinner-border spinner-border-sm me-2"></span> Eliminando...
        } @else {
          <i class="bi bi-trash-fill me-2"></i> Eliminar
        }
      </button>
    </div>

    <!-- Mensaje de éxito -->
    @if (success()) {
      <div class="alert alert-success mt-4 rounded-pill shadow-sm">
        <i class="bi bi-check-circle-fill"></i> Variedad eliminada correctamente.
      </div>
    }

    <!-- Mensaje de error -->
    @if (error()) {
      <div class="alert alert-danger mt-4 rounded-pill shadow-sm">
        <i class="bi bi-x-circle-fill"></i> {{ error() }}
      </div>
    }
  </div>
</div>
